import type { SxProps, Theme } from '@mui/material';
import type { ReactNode } from 'react';

import type { DesignSystemCardSize } from '../../theme/design-system/types';
import type { TypographyProps } from '../Typography/Typography';
import { Typography } from '../Typography/Typography';
import { useSlotContext } from '../../utils/useSlotContext';
import { DEFAULT_CARD_SIZE } from './Card.constants';

type CardDescriptionProps = {
    children: ReactNode;
    sx?: SxProps<Theme>;
};

const descriptionVariantMap: Record<
    DesignSystemCardSize,
    TypographyProps['variant']
> = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
};

export const CardDescription = (props: CardDescriptionProps) => {
    const { size = DEFAULT_CARD_SIZE } = useSlotContext(props, 'card');
    const variant = descriptionVariantMap[size];

    return (
        <Typography
            variant={variant}
            color="ds.fg.neutral.primary"
            sx={props.sx}
        >
            {props.children}
        </Typography>
    );
};
